import Service from './abstract';
import _ from 'lodash';

const defaultWith = {
    with: 'events,type',
};
class Events extends Service {
    constructor () {
        super('events');
    }

    getEvents (options = {}) {
        const opts = {
            url: `${this.basePath}/events`,
            qs: _.defaultsDeep({}, options, defaultWith),
        };

        return this.get(opts);
    }

    getEventsByToken (options = {}) {
        const opts = {
            url: `${this.basePath}/tokens`,
            qs: _.defaultsDeep({}, options, defaultWith),
        };

        return this.get(opts);
    }
}

export default new Events();
